import { useState } from 'react';
import WorkAnalysis from './widgets/WorkAnalysis';
import WorkAssignment from './widgets/WorkAssignment';

const UnifiedWorkView = () => {
  const [selectedTactics, setSelectedTactics] = useState<string[]>([]);
  const [tacticPoints, setTacticPoints] = useState<
    { x: number; y: number; id: string }[]
  >([]);
  const [point2, setPoint2] = useState<{ x: number; y: number } | null>(null);
  const [endScrollPoint, setEndScrollPoint] = useState<{
    x: number;
    y: number;
  } | null>(null);

  return (
    <div>
      <div className="d-flex gap-5">
        <WorkAnalysis
          selectedTactics={selectedTactics}
          setSelectedTactics={setSelectedTactics}
          setTacticPoints={setTacticPoints}
          setEndScrollPoint={setEndScrollPoint}
          tacticPoints={tacticPoints}
          point2={point2}
          endScrollPoint={endScrollPoint}
        />
        <WorkAssignment
          selectedTactics={selectedTactics}
          setSelectedTactics={setSelectedTactics}
          setPoint2={setPoint2}
        />
      </div>
    </div>
  );
};

export default UnifiedWorkView;
